(() => {
  'use strict';
  const KEY = 'avontic-business-quote-draft-v2';
  const PREVIOUS = 'avontic-business-quote-previous-v3';
  const read = key => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const save = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } };
  const apply = async () => {
    const root = document.querySelector('[data-avb]');
    const form = root?.querySelector('form[data-avb-form], form.avb-quote');
    if (!form || root.querySelector('[data-avb-success-scope]') || root.dataset.avtQuoteReady) return;
    root.dataset.avtQuoteReady = 'true';
    const panels = [...root.querySelectorAll('[data-avt-quote-context]')];
    const text = { ...JSON.parse(panels[0]?.querySelector('[data-avt-quote-text]')?.textContent || '{}'), ...JSON.parse(panels[0]?.querySelector('[data-avt-quote-state-text]')?.textContent || '{}') };
    const labels = {
      saved: root.dataset.quoteSavedLabel || root.dataset.savedLabel || text.selection,
      totalOne: root.dataset.quoteTotalOne || text.total,
      totalOther: root.dataset.quoteTotalOther || text.total,
      packOne: root.dataset.quotePackOne,
      packOther: root.dataset.quotePackOther,
    };
    const field = selector => form.querySelector(selector);
    let previous = read(KEY);
    let savedRequest = Boolean(previous && field('[data-avb-selected-setups]')?.value);
    const totalText = count => (Number(count) === 1 ? labels.totalOne : labels.totalOther).replace('__COUNT__', String(count));
    const packText = (packs, units) => {
      const template = Number(packs) === 1 ? labels.packOne : labels.packOther;
      return template ? template.replace('__PACKS__', String(packs)).replace('__UNITS__', String(units)) : '';
    };
    const templatePattern = template => new RegExp('^' + (template || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      .replaceAll('__COUNT__', '(?<count>\\d+)').replaceAll('__PACKS__', '(?<packs>\\d+)').replaceAll('__UNITS__', '(?<units>\\d+)') + '$');
    const totalPatterns = [text.total, labels.totalOne, labels.totalOther].filter(Boolean).map(templatePattern);
    const packPattern = templatePattern(text.packs);
    // Older drafts retain their original text. Clean their visible summary only;
    // the stored request and submission fields stay intact for recovery.
    const visibleSummary = summary => summary.split('\n').flatMap(line => {
      const value = line.trim();
      if (totalPatterns.some(pattern => pattern.test(value)) || /^Current request: \d+ devices?$/.test(value)) return [];
      const pack = value.match(packPattern) || value.match(/^(?<packs>\d+) packs? × (?<units>\d+) devices? = (?<count>\d+) devices?$/);
      return [pack ? (packText(pack.groups.packs, pack.groups.units) || line) : line];
    }).join('\n').trim();
    panels.forEach(panel => {
      panel.setAttribute('aria-label', text.selection);
      panel.querySelector('.avt-quote-context__title').textContent = text.selection;
      panel.querySelector('[data-avt-quote-previous]').textContent = text.previous_kept;
      ['append', 'resume', 'replace'].forEach(action => { panel.querySelector(`[data-avt-quote-${action}]`).textContent = text[action]; });
    });
    const status = message => panels.forEach(panel => { panel.hidden = false; panel.querySelector('[data-avt-quote-status]').textContent = message; });
    const render = () => {
      const summary = field('[data-avb-selected-setups]')?.value || '';
      const total = field('[data-avb-total-quantity]')?.value || '';
      panels.forEach(panel => {
        if (summary) panel.hidden = false;
        const title = savedRequest ? labels.saved : text.selection;
        panel.setAttribute('aria-label', title);
        panel.querySelector('.avt-quote-context__title').textContent = title;
        panel.querySelector('[data-avt-quote-summary]').textContent = visibleSummary(summary);
        panel.querySelector('[data-avt-quote-total]').textContent = total ? totalText(total) : '';
      });
    };
    root.addEventListener('avontic:quote-updated', render);
    const markEdited = () => { savedRequest = false; render(); };
    form.addEventListener('input', markEdited);
    form.addEventListener('change', markEdited);
    root.querySelector('form.avb-quick__form [name="contact[Estimated quantity]"]')?.addEventListener('input', markEdited);
    root.addEventListener('avontic:quote-cleared', () => {
      previous = null;
      savedRequest = false;
      panels.forEach(panel => { panel.querySelector('[data-avt-quote-draft-actions]').hidden = true; });
      render();
    });
    render();
    const params = new URLSearchParams(location.search);
    const handle = params.get('product');
    const variantId = params.get('variant');
    const planningQuantity = Number(params.get('quantity'));
    const planning = !variantId && Number.isInteger(planningQuantity) && planningQuantity > 0 && planningQuantity <= 100000;
    if (handle && !/^[\p{L}\p{N}™®_-]+$/u.test(handle)) return;
    if (!handle && !planning) return;
    const preference = params.get('case') || handle || 'help';
    if (!variantId && !planning) {
      const choice = [...form.querySelectorAll('[name="contact[Case preference]"]')].find(input => input.value === preference);
      if (choice) { choice.checked = true; choice.dispatchEvent(new Event('change', { bubbles: true })); }
      if (params.get('quantity')) status(text.unverified);
      return;
    }
    if (variantId && !/^\d+$/.test(variantId)) { status(text.unverified); return; }
    let incoming;
    status(text.loading);
    const submits = [...root.querySelectorAll('button[type="submit"]')].map(button => ({ button, disabled: button.disabled }));
    submits.forEach(({ button }) => { button.disabled = true; });
    try {
      if (planning) {
        let devices = [];
        try {
          const candidate = JSON.parse(params.get('devices') || '[]');
          if (Array.isArray(candidate) && candidate.length <= 3 && candidate.every(item => typeof item.model === 'string' && item.model.length <= 180 && Number.isInteger(item.quantity) && item.quantity > 0 && item.quantity <= 100000) && candidate.reduce((sum, item) => sum + item.quantity, 0) === planningQuantity) devices = candidate;
        } catch (_) { /* A plain quantity link can still start a planning request. */ }
        incoming = { key: `planning:${params.get('source') || ''}:${planningQuantity}:${JSON.stringify(devices)}`, title: '', model: '', quantity: planningQuantity, preference, devices: devices.length ? devices : undefined,
          summary: [params.get('source') === 'loadout-studio' ? 'Loadout Studio' : '', ...devices.map(item => `${item.model} × ${item.quantity}`)].filter(Boolean).join('\n') };
      } else {
      const prefix = location.pathname.split('/pages/')[0];
      const url = new URL(`${prefix}/products/${encodeURIComponent(handle)}`, location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('view', 'avontic-selection');
      ['preview_theme_id', '_fd', 'pb', 'country', 'currency', 'locale'].forEach(key => { if (params.has(key)) url.searchParams.set(key, params.get(key)); });
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error('request');
      const product = await response.json();
      const variant = product.variant;
      if (product.handle !== handle || !variant || variant.id !== variantId) throw new Error('selection');
      const packCount = Number(params.get('pack_count'));
      const requested = Number(params.get('quantity'));
      const quantity = Number.isInteger(packCount) && packCount > 0 ? packCount * variant.units : requested;
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100000) throw new Error('quantity');
      const options = product.optionNames.map((name, index) => ({ name, value: variant.options[index] }));
      const model = options.find(option => /model|device|size/i.test(option.name))?.value || '';
      const colors = options.filter(option => /colou?r/i.test(option.name)).map(option => `${option.name}: ${option.value}`).join(' / ');
      const aNumber = [params.get('model'), params.get('smartfit_model')].find(value => /^A\d{4}$/.test(value || '') && model.includes(value)) || '';
      const optionText = options.filter(option => option.name !== 'Title').map(option => `${option.name}: ${option.value}`).join(' · ');
      const packs = variant.units > 1 && quantity % variant.units === 0 ? packText(quantity / variant.units, variant.units) : '';
      incoming = { key: `${handle}:${variantId}:${quantity}`, title: product.title, model, colors, aNumber, quantity, preference,
        summary: [product.title, optionText, packs, variant.available ? '' : text.availability].filter(Boolean).join('\n') };
      }
      const savedKey = previous?.fields?.find(item => item.name === 'contact[Selection key]')?.value;
      if (savedKey === incoming.key) {
        previous = read(PREVIOUS);
        savedRequest = true;
        status(text.restored);
      } else {
        if (previous?.fields?.some(item => item.name === 'contact[Estimated quantity]' && Number(item.value) > 0) || previous?.devices?.some(item => item.model || Number(item.quantity) > 0)) save(PREVIOUS, previous);
        else previous = null;
        const detail = { mode: 'replace', selection: incoming };
        root.dispatchEvent(new CustomEvent('avontic:quote-selection', { detail }));
        if (!detail.applied) throw new Error('form');
        savedRequest = false;
        status(planning ? text.planning_loaded : text.loaded);
      }
      panels.forEach(panel => {
        panel.querySelector('[data-avt-quote-draft-actions]').hidden = !previous;
        const run = mode => {
          const detail = { mode, selection: incoming, draft: previous };
          root.dispatchEvent(new CustomEvent('avontic:quote-selection', { detail }));
          if (!detail.applied) { status(text.limit); return; }
          savedRequest = mode === 'resume';
          status(mode === 'resume' ? text.resumed : mode === 'append' ? text.appended : planning ? text.planning_loaded : text.loaded);
          panels.forEach(item => {
            item.querySelector('[data-avt-quote-append]').hidden = mode === 'append';
            item.querySelector('[data-avt-quote-replace]').hidden = mode === 'replace';
          });
          render();
        };
        panel.querySelector('[data-avt-quote-append]').addEventListener('click', () => run('append'));
        panel.querySelector('[data-avt-quote-resume]').addEventListener('click', () => run('resume'));
        panel.querySelector('[data-avt-quote-replace]').addEventListener('click', () => run('replace'));
      });
      render();
    } catch (_) { status(text.unverified); }
    finally { submits.forEach(({ button, disabled }) => { button.disabled = disabled; }); }
  };
  if (document.readyState === 'complete') apply();
  else window.addEventListener('load', apply, { once: true });
})();

